import {VERSION_ONE, WidgetProps} from "../widget-types";

const DEFAULT_VERSION = VERSION_ONE;

const getVersion = (widgetProps: WidgetProps): string => {
    return widgetProps.version ?? DEFAULT_VERSION;
}

const WidgetUtils = {
    getVersion,
}

export default WidgetUtils;
